import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/staff`;

export interface Teacher {
  id: number;
  firstName: string;
  lastName: string;
  employeeId: string;
  email: string;
  subject: string;
  schoolId: number;
  // Add other fields as needed
}

export const getAllTeacher = async (): Promise<Teacher[]> => {
  const response = await axios.get<Teacher[]>(API_URL);
  return response.data;
};

export interface TeacherFormData {
  firstName: string;
  lastName: string;
  employeeId: string;
  dateOfBirth: string;
  gender: string;
  address: string;
  phone: string;
  email: string;
  qualification: string;
  subject: string;
  joiningDate: string;
  schoolId: number;
  active?: boolean;
}

export const createTeacher = async (teacherData: TeacherFormData): Promise<Teacher> => {
  const response = await axios.post<Teacher>(API_URL, teacherData);
  return response.data;
};

export const updateTeacher = async (id: number, teacherData: TeacherFormData): Promise<Teacher> => {
  const response = await axios.put<Teacher>(`${API_URL}/${id}`, teacherData);
  return response.data;
};

export const deleteTeacherService = async (id: number): Promise<void> => {
  await axios.delete(`${API_URL}/${id}`);
};
